document.addEventListener('DOMContentLoaded', function() {
  // Function to hide the Decline button on the cookie banner
  function hideDeclineButton() {
    var declineButton = document.getElementById('shopify-pc__banner__btn-decline');
    if (declineButton) {
      declineButton.style.display = 'none';
    }
  }

  // Function to hide the Decline All button in Manage Cookies
  function hideDeclineAllButton() {
    var declineAllButton = document.getElementById('shopify-pc__prefs__header-decline');
    if (declineAllButton) {
      declineAllButton.style.display = 'none';
    }
  }

  // Function to check all checkboxes
  function checkAllCheckboxes() {
    var checkboxes = document.querySelectorAll('.shopify-pc__prefs__options input[type="checkbox"]');
    checkboxes.forEach(function(checkbox) {
      checkbox.checked = true;
      // Ensure the visual state of the checkbox is updated
      var parentLabel = checkbox.closest('label');
      if (parentLabel) {
        var checkedSVG = parentLabel.querySelector('svg[data-icon-type="checked"]');
        var uncheckedSVG = parentLabel.querySelector('svg[data-icon-type="unchecked"]');
        if (checkedSVG && uncheckedSVG) {
          checkedSVG.style.display = 'block';
          uncheckedSVG.style.display = 'none';
        }
      }
    });
  }

  // Attempt to hide buttons and check all checkboxes immediately
  hideDeclineButton();
  checkAllCheckboxes();
  hideDeclineAllButton();

  // Observe the body for any child elements being added (like the cookie banner)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes) {
        hideDeclineButton();
        checkAllCheckboxes();
        hideDeclineAllButton();
      }
    });
  });

  // Configure the observer to watch for child nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Additional observer for specific cookie preferences section
  var prefsObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes) {
        checkAllCheckboxes();
      }
    });
  });

  // Configure the observer to watch for child nodes within the cookie preferences section
  var cookiePrefsSection = document.querySelector('.shopify-pc__prefs__dialog');
  if (cookiePrefsSection) {
    prefsObserver.observe(cookiePrefsSection, {
      childList: true,
      subtree: true
    });
  }

  // Ensure checkboxes are checked when the preferences dialog is opened
  document.querySelector('.shopify-pc__banner__btn-manage-prefs').addEventListener('click', function() {
    setTimeout(checkAllCheckboxes, 500);
  });
});